import { HttpEvent, HttpHandler, HttpInterceptor, HttpResponseBase, HttpRequest, HttpErrorResponse, HttpHandlerFn } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';

import { AuthenticationService } from '../authentication/authentication.service';

export function AuthInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn ): Observable<HttpEvent<unknown>> {

      const url = request.url;
      const isApiCall = url.search(/api/gi) != -1;
      const service = inject(AuthenticationService);

      if (isApiCall) {
        const t = service.idToken;

        request = request.clone({
          headers: request.headers.set('Authorization', 'Bearer ' + service.idToken)
            .append('Access-Control-Allow-Origin', '*')
        });
      }

      return next(request).pipe(catchError(
        err => {
          if (isApiCall && err.status === 401) {
            service.logout();
          }

          return throwError(() => err);
        }
      ));

  //return next(request).pipe(tap(
  //  () => { },
  //  (err: HttpResponseBase) => {
  //    if (isApiCall && err.status === 401) {
  //      this.service.logout();
  //    }
  //  }
  //));
}

//@Injectable()
//export class AuthInterceptor implements HttpInterceptor {

//  constructor(
//    private service: AuthenticationService
//  ) { }

//  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
//  {

//    const url = request.url;
//    const isApiCall = url.search(/api/gi) != -1;

//    if (isApiCall) {
//      const t = this.service.idToken;

//      request = request.clone({
//        headers: request.headers.set('Authorization', 'Bearer ' + this.service.idToken)
//          .append('Access-Control-Allow-Origin', '*')
//      });
//    }
//    //return next.handle(request).pipe(tap(
//    //  () => { },
//    //  (err: HttpResponseBase) => {
//    //    if (isApiCall && err.status === 401) {
//    //      this.service.logout();
//    //    }
//    //  }
//    //));

//    return next.handle(request).pipe(
//      catchError((error: HttpErrorResponse) => {
//        if (isApiCall && error.status === 401) {
//          // Handle 401 error
//          this.service.logout();
//        } else {
//          return throwError(error);
//        }
//      })
//    );

//  }
//}
